/* Egg Back Home — filtros das colecções · 2026-09-07
 *
 * Duas coisas, e uma armadilha que as apanhou às duas.
 *
 * A ARMADILHA: o ficheiro está pendurado no <head> com `script_tag`, que não
 * põe `defer`. Corria antes de o <body> existir, não encontrava nada e saía
 * pela porta do `return` sem dizer nada a ninguém. Estar carregado não é estar
 * a correr. Agora espera pelo DOM — e o `defer` na etiqueta é o cinto a mais.
 *
 * 1) A MEDIDA POR BAIXO DO NOME. Os rótulos do filtro «Tamanho» vêm do
 *    metaobjecto como um texto só — «Pequena · 100–300 ml» — e o CSS não sabe
 *    pintar metade de um texto. Aqui parte-se pelo «·» e embrulha-se a segunda
 *    metade, para ela poder ir para baixo do nome e mais clara. É só
 *    apresentação: sem JavaScript lê-se a linha corrida de sempre, que também
 *    está certa, e o leitor de ecrã continua a ouvir o texto inteiro.
 *
 * 2) O VOLTAR AO TOPO. Ao mudar um filtro, a grelha é substituída por AJAX e a
 *    página fica onde estava. Quem tinha rolado para baixo não vê acontecer
 *    nada. Não há evento do tema para isto — o JS vem minificado —, por isso
 *    observa-se a grelha e sobe-se aos resultados, mas SÓ se eles estiverem
 *    fora do ecrã. Quem já está em cima não sente nada, e respeita-se quem
 *    pediu menos movimento.
 */
(function () {
  function arrancar() {
    reaplicar();
    setaDeEncolher();
    botaoOrdenar();
    voltarAoTopo();
    vigiarReescritas();

    // as fotos entram depois do DOM e mudam a altura das caixas
    window.addEventListener('load', alinharColuna);

    var atraso;
    window.addEventListener('resize', function () {
      clearTimeout(atraso);
      atraso = setTimeout(alinharColuna, 200);
    });
  }

  // Tudo o que tem de voltar a ser feito quando o tema reescreve os filtros.
  function reaplicar() {
    medidas();
    cortarListas();
    precoEmTexto();
    alinharColuna();
    if (typeof window.__ebhSincronizarSeta === 'function') window.__ebhSincronizarSeta();
  }

  // O tema reescreve os filtros a cada actualização por AJAX. O observador vê
  // as suas próprias escritas — partir um rótulo é mexer no DOM que ele vigia —,
  // por isso desliga-se enquanto trabalha e volta a ligar depois.
  function vigiarReescritas() {
    if (!window.MutationObserver) return;
    var caixas = document.querySelectorAll('.filter-sidebar, .filter-drawer, .filter-bar');
    if (!caixas.length) return;
    var opcoes = { childList: true, subtree: true };
    var vigia = new MutationObserver(function () {
      vigia.disconnect();
      reaplicar();
      for (var k = 0; k < caixas.length; k++) vigia.observe(caixas[k], opcoes);
    });
    for (var j = 0; j < caixas.length; j++) vigia.observe(caixas[j], opcoes);
  }

  /* ---- listas compridas cortadas, com uma seta ao centro ----
   *
   * Doze cores, catorze colecções, dezasseis tipos: abertas de uma vez, a
   * coluna passava dos 1.800px e ninguém a via inteira. Mostram-se seis e o
   * resto abre numa seta ao centro — que é o desenho aprovado.
   *
   * Duas regras que evitam esconder o que interessa: uma lista já ABRE aberta
   * se algum valor escolhido estiver para lá do sexto, e o botão diz quantos
   * faltam para não ser um salto no escuro.
   */
  function cortarListas() {
    var LIMITE = 6;
    var listas = document.querySelectorAll('.filter-sidebar .filter-drawer__list');

    for (var i = 0; i < listas.length; i++) {
      var L = listas[i];
      if (L.parentNode.getAttribute('data-filter-type') === 'price_range') continue;

      var itens = L.children;
      var jaTem = L.nextSibling && L.nextSibling.className === 'ebh-mais';
      if (itens.length <= LIMITE) {
        if (jaTem) L.nextSibling.remove();
        L.classList.remove('ebh-lista-cortada', 'ebh-aberta');
        continue;
      }
      if (jaTem) continue;

      L.classList.add('ebh-lista-cortada');

      // um valor escolhido escondido seria mentir sobre o estado do filtro
      for (var k = LIMITE; k < itens.length; k++) {
        if (itens[k].querySelector('input:checked')) { L.classList.add('ebh-aberta'); break; }
      }

      var botao = document.createElement('button');
      botao.type = 'button';
      botao.className = 'ebh-mais';
      botao.innerHTML = '<span class="ebh-mais__n"></span><span class="ebh-mais__v"></span>';
      var conta = botao.firstChild;

      (function (L, botao, conta, quantos) {
        function pintar() {
          var aberta = L.classList.contains('ebh-aberta');
          botao.setAttribute('aria-expanded', aberta ? 'true' : 'false');
          conta.textContent = aberta ? '' : '+' + quantos;
        }
        botao.addEventListener('click', function () {
          L.classList.toggle('ebh-aberta');
          pintar();
        });
        pintar();
      })(L, botao, conta, itens.length - LIMITE);

      L.parentNode.insertBefore(botao, L.nextSibling);
    }
  }

  /* ---- 1. a medida numa linha à parte ---- */
  function medidas() {
    var SEPARADOR = ' · ';   // «Nome · medida»

    function partir() {
      var rotulos = document.querySelectorAll('.filter-item__label');
      for (var i = 0; i < rotulos.length; i++) {
        var el = rotulos[i];
        if (el.querySelector('.ebh-medida')) continue;       // já feito
        var texto = el.textContent;
        var corte = texto.indexOf(SEPARADOR);
        if (corte < 0) continue;

        var medida = document.createElement('span');
        medida.className = 'ebh-medida';
        medida.textContent = texto.slice(corte + SEPARADOR.length).trim();

        el.textContent = texto.slice(0, corte).trim();
        el.appendChild(medida);
      }
    }

    partir();
  }

  /* ---- 2. o preço sem caixas: só o cursor e os dois números ----
   *
   * As duas caixas de número ocupavam 38px e uma linha inteira para dizer o
   * que o cursor já mostra. Ficam escondidas mas VIVAS — são elas que levam
   * `filter.v.price.gte` e `lte` ao formulário; apagá-las era perder o filtro.
   * Por baixo do cursor ficam os dois extremos em texto, que acompanham o
   * arrastar.
   */
  function precoEmTexto() {
    var caixas = document.querySelectorAll('.filter-drawer__price-range');

    for (var i = 0; i < caixas.length; i++) {
      (function (caixa) {
        if (caixa.querySelector('.ebh-preco-valores')) return;

        var minIn = caixa.querySelector('[data-min-range-input]');
        var maxIn = caixa.querySelector('[data-max-range-input]');
        var cursor = caixa.querySelector('.filter-drawer__slider');
        if (!minIn || !maxIn || !cursor) return;

        var moeda = caixa.querySelector('.filter-drawer__price-range-currency');
        var simbolo = moeda ? moeda.textContent.trim() : '';

        var linha = document.createElement('div');
        linha.className = 'ebh-preco-valores';
        var de = document.createElement('span');
        var ate = document.createElement('span');
        linha.appendChild(de);
        linha.appendChild(ate);
        cursor.parentNode.insertBefore(linha, cursor.nextSibling);

        function escrever() {
          // vazio = extremo por omissão, que é o que o campo traz no placeholder
          de.textContent = simbolo + (minIn.value || minIn.placeholder || '0');
          ate.textContent = simbolo + (maxIn.value || maxIn.placeholder || '');
        }

        escrever();
        minIn.addEventListener('input', escrever);
        maxIn.addEventListener('input', escrever);
        // o noUiSlider escreve nos campos sem disparar eventos: ouve-se ele.
        if (cursor.noUiSlider) cursor.noUiSlider.on('update', escrever);
      })(caixas[i]);
    }
  }

  /* ---- a coluna arranca à altura da primeira imagem ----
   *
   * O topo do cartão nem sempre é o topo da imagem: nas colecções com selo de
   * desconto acima da foto, o cartão começa mais cedo e a coluna ficava um
   * dedo acima das imagens. A distância não é fixa — depende de haver selo e
   * de quantas linhas ele ocupa —, por isso mede-se em vez de se adivinhar.
   *
   * Fica um valor no CSS como ponto de partida, para não haver salto enquanto
   * isto não corre.
   */
  /* Onde a foto COMEÇA A VER-SE, que não é onde a caixa dela começa.
   *
   * Com `object-fit: contain`, uma foto mais larga do que a caixa fica
   * encaixada ao centro e sobra vazio em cima e em baixo — às vezes 50px. Era
   * esse vazio que punha a coluna acima das fotos: eu alinhava pela caixa.
   * Aqui refaz-se a conta do navegador — escala, altura desenhada, sobra a
   * dividir por dois — e devolve-se o primeiro pixel pintado.
   */
  function topoDesenhado(el) {
    var r = el.getBoundingClientRect();
    if (el.tagName !== 'IMG') return r.top;

    var ln = el.naturalWidth, an = el.naturalHeight;
    if (!ln || !an) return r.top;
    if (getComputedStyle(el).objectFit !== 'contain') return r.top;

    var escala = Math.min(r.width / ln, r.height / an);
    return r.top + (r.height - an * escala) / 2;
  }

  function alinharColuna() {
    if (window.innerWidth < 960) return;
    var interior = document.querySelector('.filter-sidebar-inner');
    if (!interior) return;

    // A FOTO, não a caixa dela. Enquanto a imagem não carrega, a caixa pode ter
    // outra altura e outro topo — medir aí dava um alinhamento que se estragava
    // assim que a foto entrasse. Por isso só se mede uma imagem já carregada, e
    // volta a medir-se quando ela chega.
    var foto = document.querySelector('.collection__products img');
    var alvo = (foto && foto.complete && foto.getBoundingClientRect().height > 40)
      ? foto
      : document.querySelector('.collection__products .product-item__media');
    if (!alvo) return;

    interior.style.marginTop = '0px';
    var desvio = topoDesenhado(alvo) - interior.getBoundingClientRect().top;
    // um desvio absurdo é sinal de que se mediu a meio de uma animação
    interior.style.marginTop = (desvio > 0 && desvio < 240) ? Math.round(desvio) + 'px' : '';

    if (foto && !foto.complete && !foto.dataset.ebhEspera) {
      foto.dataset.ebhEspera = '1';
      foto.addEventListener('load', alinharColuna, { once: true });
    }
  }

  /* ---- o botão «Ordenar» do telemóvel ----
   *
   * Abre o mesmo painel dos filtros — disso trata o tema — e depois abre o
   * grupo da ordenação e leva-o à vista. Sem isto, quem carregasse em
   * «Ordenar» via os filtros e tinha de procurar onde estava a ordem.
   */
  function botaoOrdenar() {
    var botao = document.querySelector('[data-ebh-ordenar]');
    if (!botao) return;

    botao.addEventListener('click', function () {
      setTimeout(function () {
        var grupo = document.querySelector('.filter-drawer .ebh-grupo-ordenar');
        if (!grupo) return;
        var caixa = grupo.querySelector('.filter-drawer__group-filter-wrapper');
        var puxador = grupo.querySelector('.filter-drawer__group-toggle');
        var lista = grupo.querySelector('.filter-drawer__list');
        if (caixa && puxador && caixa.getAttribute('aria-hidden') !== 'false') puxador.click();
        grupo.scrollIntoView({ block: 'start' });

        // O tema abre o grupo animando a altura, e calcula-a no instante do
        // clique — que aqui é durante a entrada do painel, quando a medida
        // ainda não é a boa. Ficavam duas opções à vista das nove. Passada a
        // animação, se a caixa continuar mais baixa do que a lista, deixa-se a
        // altura em automático.
        setTimeout(function () {
          if (!caixa || !lista) return;
          if (caixa.getBoundingClientRect().height < lista.getBoundingClientRect().height) {
            caixa.style.height = 'auto';
          }
        }, 520);
      }, 420);   // o painel entra a deslizar; abrir antes disso não pega
    });
  }

  /* ---- 3. a setinha que encolhe a coluna ----
   *
   * O tema só oferecia um link de texto na barra, «Ocultar filtros», longe da
   * coluna que esconde. A seta vive na aresta dela: aponta para dentro para a
   * encolher e para fora para a trazer de volta.
   *
   * Não reimplementa nada — carrega no botão do tema, que é quem sabe abrir e
   * fechar. E só esconde o link de texto DEPOIS de se instalar: se este ficheiro
   * não correr, o link continua lá e ninguém fica sem filtros.
   */
  function setaDeEncolher() {
    var area = document.querySelector('.collection__main-area');
    var coluna = document.querySelector('[data-filter-sidebar]');
    var botaoTema = document.querySelector('.filter-bar__button--filters[aria-controls="filter-sidebar"]');
    if (!area || !coluna || !botaoTema || area.querySelector('.ebh-seta')) return;

    var seta = document.createElement('button');
    seta.type = 'button';
    seta.className = 'ebh-seta';
    seta.setAttribute('aria-controls', 'filter-sidebar');
    seta.innerHTML =
      '<span class="ebh-seta__v"></span>' +
      '<span class="ebh-seta__palavra"></span>' +
      '<span class="ebh-seta__conta"></span>';
    var palavra = seta.querySelector('.ebh-seta__palavra');
    var conta = seta.querySelector('.ebh-seta__conta');

    // O estado lê-se na COLUNA, não no botão do tema: o `aria-expanded` dele é
    // o do seu próprio menu e está invertido em relação ao que se vê — com a
    // coluna aberta o botão diz «false». Seguir o botão punha a seta ao contrário.
    function sincronizar() {
      var aberta = coluna.getAttribute('aria-expanded') === 'true';
      seta.setAttribute('aria-expanded', aberta ? 'true' : 'false');
      // os dois títulos já vêm traduzidos do tema
      seta.setAttribute('aria-label', aberta
        ? (botaoTema.getAttribute('data-expanded-title') || '')
        : (botaoTema.getAttribute('data-collapsed-title') || ''));
      seta.title = seta.getAttribute('aria-label');
      // o estado também vai para o <body>: é por ele que as etiquetas do
      // escolhido sabem se se hão-de encostar à grelha ou voltar à esquerda
      document.body.classList.toggle('ebh-coluna-aberta', aberta);

      // Fechada, a tira diz ao que vem: a palavra ao alto e a conta do que
      // está ligado. A conta lê-se nas pastilhas do escolhido, que são a mesma
      // verdade e voltam a ser escritas a cada actualização por AJAX.
      palavra.textContent = botaoTema.getAttribute('data-collapsed-title') || '';
      // o «Limpar filtros» partilha a classe das pastilhas e entrava na conta:
      // dois filtros ligados davam «3»
      var ligados = document.querySelectorAll(
        '.filter-bar .active-filters__active-filter:not(.active-filters__clear)'
      ).length;
      conta.textContent = ligados > 0 ? ligados : '';
      conta.hidden = ligados === 0;
    }

    seta.addEventListener('click', function () {
      botaoTema.click();
    });

    window.__ebhSincronizarSeta = sincronizar;
    // Dentro do cabeçalho da coluna, não ao lado dela: agora que a coluna é um
    // painel com cor e cantos próprios, um botão solto ao lado ficava a
    // flutuar no chão da página, sem pertencer a nada. Aqui alinha com o
    // «Filtrar» e com o «Limpar tudo», que é o que ele fecha.
    var cabecalho = coluna.querySelector('.filter-sidebar__head');
    if (cabecalho) cabecalho.appendChild(seta);
    else coluna.parentNode.insertBefore(seta, coluna.nextSibling);
    // no <body> porque o link de texto do tema vive na barra, que fica FORA
    // da área principal — uma classe na área nunca lhe chegava.
    document.body.classList.add('ebh-com-seta');
    sincronizar();

    if (window.MutationObserver) {
      new MutationObserver(sincronizar).observe(coluna, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    }
  }

  /* ---- 4. subir aos resultados depois de filtrar ---- */
  function voltarAoTopo() {
    var grelha = document.querySelector('.collection__products, [data-collection-products]');
    if (!grelha || !window.MutationObserver) return;

    var ancora = document.querySelector('.filter-bar, .filter-sidebar, .collection__toolbar') || grelha;
    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ultimo = 0;

    new MutationObserver(function () {
      var agora = Date.now();
      if (agora - ultimo < 400) return;   // o tema mexe na grelha várias vezes por actualização
      ultimo = agora;

      var topo = ancora.getBoundingClientRect().top;
      if (topo >= 0) return;              // já está à vista: não mexer

      window.scrollTo({
        top: window.scrollY + topo - 16,
        behavior: suave ? 'smooth' : 'auto'
      });
    }).observe(grelha, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
